import { BaseTemplateElement } from './base-template-element.model';
import { Base } from './report-editor.model';
import {
    ChartKpiDto,
    DatapointFiltersDto,
    HistoricalDatapointDto,
    InOperationFilterTypeDto,
    LegendDto,
} from './template-dto.model';

export class LineChartElement extends BaseTemplateElement {
    description: string;
    datapoints: HistoricalDatapointDto[];
    legend: LegendDto[];
    kpi: ChartKpiDto;
    inOperationFilterType: InOperationFilterTypeDto;
    datapointFilters: DatapointFiltersDto[];
    useTitle?: boolean;

    constructor(
        base: Base,
        description: string,
        datapoints: HistoricalDatapointDto[],
        legend: LegendDto[],
        kpi: ChartKpiDto,
        inOperationFilterType: InOperationFilterTypeDto,
        datapointFilters: DatapointFiltersDto[],
    ) {
        super(base);
        this.description = description;
        this.datapoints = datapoints;
        this.legend = legend;
        this.kpi = kpi;
        this.inOperationFilterType = inOperationFilterType;
        this.datapointFilters = datapointFilters;
    }
}
